import $ from 'jquery';
window.$ = window.jQuery = $;

import 'bootstrap';

import 'summernote/dist/summernote-lite';
